module.exports = __webpack_public_path__ + "img/4081591.png";